import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import Iridescence from '../components/Iridescence';

const Splash = () => {
  const navigate = useNavigate();
  const { user, loading } = useAuth();

  useEffect(() => {
    if (!loading) {
      const timer = setTimeout(() => {
        navigate('/login');
      }, 2000);
      return () => clearTimeout(timer);
    }
  }, [loading, navigate]);

  const [logoVisible, setLogoVisible] = useState(false);
  const [logoFailed, setLogoFailed] = useState(false);

  useEffect(() => {
    setTimeout(() => setLogoVisible(true), 300);
  }, []);

  return (
    <>
      <style>
        {`
          @keyframes blurIn {
            0% {
              opacity: 0;
              filter: blur(40px);
              transform: scale(0.8);
            }
            100% {
              opacity: 1;
              filter: blur(0);
              transform: scale(1);
            }
          }
          .blur-in {
            animation: blurIn 1.5s cubic-bezier(0.4, 0, 0.2, 1) forwards;
          }
        `}
      </style>
      <div
        className="h-screen relative overflow-hidden bg-gradient-to-br from-indigo-900 via-slate-900 to-indigo-700"
        style={{ touchAction: 'pan-y' }}
      >
        <div className="fixed inset-0 pointer-events-none">
          <Iridescence 
            color={[0.18, 0.16, 0.31]}
            mouseReact={true}
            amplitude={0.15}
            speed={0.8}
          />
        </div>
        <div className="absolute inset-0 flex items-center justify-center z-10">
          <div className="text-center">
            {logoVisible && !logoFailed && (
              <img 
                src="/splash-logo.webp" 
                alt="CANDIGATE Logo" 
                className="w-64 h-64 mx-auto drop-shadow-2xl blur-in object-contain"
                onError={() => setLogoFailed(true)}
              />
            )}
            {(logoFailed || !logoVisible) && (
              <h1 className="text-white text-4xl font-bold tracking-wide drop-shadow-lg">CANDIGATE</h1>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default Splash;
